import api from './api/client';
import { Suspense, Fragment, lazy } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';

import Loader from './components/Loader/Loader';
import AdminLayout from './layouts/AdminLayout';

import GuestGuard from './components/Auth/GuestGuard';
import AuthGuard from './components/Auth/AuthGuard';
import RoleBasedGuard from './components/Auth/RoleBasedGuard';

import { BASE_URL } from './config/constant';

import BasicButtons from './views/ui-elements/basic/BasicButtons';
import BasicButton1 from './views/ui-elements/basic/BasicButton1.js';
import BasicButtons1 from './views/ui-elements/basic/BasicButtons1.js';
import BasicButton22 from './views/ui-elements/basic/BasicButton22.js';
import BasicButton00122 from './views/ui-elements/basic/BasicButton00122.js';
import BasicButton1021 from './views/ui-elements/basic/BasicButton1021.js';
import BasicButton20 from './views/ui-elements/basic/BasicButton20.js';
import BasicButton21 from './views/ui-elements/basic/BasicButton21.js';
import BasicBadges from './views/ui-elements/basic/BasicBadges';
import BasicBreadcrumb1 from './views/ui-elements/basic/BasicBreadcrumb1';
import Sales from './views/ui-elements/basic/Sales.js';
import SalesViewPage from './views/ui-elements/basic/SalesViewPage.js';
import SalesEditPage from './views/ui-elements/basic/SalesEditPage.js';
import BasicBreadcrumbs01 from './views/ui-elements/basic/BasicBreadcrumbs01.js';
import ManualJournalList from './views/ui-elements/basic/BasicBreadcrumbs03.js';
import FarmProfile from './views/ui-elements/basic/BasicBreadcrumbs04.js';
import BasicTabsPills101 from './views/ui-elements/basic/BasicTabsPills101.js';
import SamplePage9 from './views/extra/SamplePage91';
import AnimalGrowthTracker from './views/tables/AnimalGrowthTracker';
import InternalConsumption from './views/charts/InternalConsumption';
import FarmItems from './views/charts/FarmItems';
import GeneralLedger from './views/charts/nvd3-chart02';
import TrialBalance from './views/charts/nvd3-chart021';
import nvd3Chart03 from './views/charts/nvd3-chart03';
import AssetPurchaseInvoice from './views/charts/AssetPurchaseInvoice';
import Profile from './views/extra/nvd3-chart4l';
import Payslip from './views/extra/nvd3-chart4ls';
import nvd3Chart100 from './views/extra/nvd3-chart100.js';
import SettingsPage from './views/extra/SettingsPage';
import SamplePage02R from './views/extra/SamplePage02R.js';
import SamplePage0101 from './views/extra/SamplePage0101';
import SamplePage0102 from './views/extra/SamplePage0102';
import SalarySettings from './views/extra/SamplePageg';
import BootstrapTable2 from './views/tables/BootstrapTable2';
import AttendanceClockPage from './views/extra/Sample02';
import AttendanceDailyPage from './views/extra/Sample02t';
import LeaveRequestPage from './views/extra/Sample02l';
import HrLeaveRequestPage from './views/extra/Sample02hl';
import LeaveCalendarPage from './views/extra/Sample02hlc';
import Sample03 from './views/extra/Sample03';
import HRManagement from './views/extra/Sample03m';
import BootstrapTable02 from './views/tables/BootstrapTable02';
import SamplePage10 from './views/extra/SamplePage10';
import SamplePage12 from './views/extra/SamplePage12';
import SamplePage012 from './views/extra/SamplePage012';
import SamplePage013 from './views/extra/SamplePage013';
import SamplePage00014 from './views/extra/SamplePage00014';
import MatingRecords from './views/extra/MatingRecords';
import SamplePage0151 from './views/extra/SamplePage0151';
import BasicTabsPills0003 from './views/ui-elements/basic/BasicTabsPills0003.js';
import BasicTabsPills03 from './views/ui-elements/basic/BasicTabsPills03';
import BasicTabsPills003 from './views/ui-elements/basic/BasicTabsPills003.js';
import BasicTabsPills0030 from './views/ui-elements/basic/BasicTabsPills0030.js';
import BasicTabsPills0031 from './views/ui-elements/basic/BasicTabsPills0031.js';
import Inventory from './views/extra/Inventory.js';
import InventoryAdd from './views/extra/InventoryAdd.js';
import InventoryReport from './views/extra/InventoryReport.js';
import BalanceSheet from './views/ui-elements/basic/BalanceSheet';
import IncomeStatement from './views/ui-elements/basic/Performance';
import CashFlow from './views/ui-elements/basic/CashFlow';
import ProfitLoss from './views/ui-elements/basic/ProfitLoss';
import AnimalTypes from './views/ui-elements/basic/AnimalTypes';
import BasicTabsPills0033 from './views/ui-elements/basic/BasicTabsPills0033.js';
import BasicTabsPills0035 from './views/ui-elements/basic/BasicTabsPills0035.js';
import BasicTabsPills0037 from './views/ui-elements/basic/BasicTabsPills0037.js';
import BasicTabsPills0039 from './views/ui-elements/basic/BasicTabsPills0039.js';
import BasicTabsPills0041 from './views/ui-elements/basic/BasicTabsPills0041.js';
import BasicTabsPills0043 from './views/ui-elements/basic/BasicTabsPills0043.js';
import GeneralLedgerReport from './views/ui-elements/basic/accounts';
import Dashboard from './views/dashboard/index.js';
import BankReconciliation from './views/forms/BankReconciliation.js';
import ReconciliationReports from './views/forms/ReconciliationReport.js';
import PayrollPaymentPage from './views/forms/PayrollPaymentPage.js';
import DefaultCyclePage from './views/tables/DefaultCycle.js';
import AnimalAnalyticsDashboard from './views/tables/AnimalAnalytics.js';
import AnimalWasteManagement from './views/tables/AnimalWasteManagement.js';
import AddSlaughterWaste from './views/tables/AddSlaughterWaste.js';
import AccountantDashboard from './views/dashboard/AccDashboard/index.js';
import SalesPage from './components/SalesPage.js';
import EggCollectionModal from './views/extra/SamplePage9.js';
import ItemDetailsPage from './components/ItemsDetailsPage.js';
import ConsumptionPages from './components/InventoryConsumptionPage.js';
import StakeholderDetailPage from './views/extra/StakeholderDetailsPage.js';
import AssetConfigPage from './components/AssetConfigPage.js';
import SiloManagement from './components/SiloManagement.js';
import AnimalMortalityHistory from './components/AnimalMortalityHistory.js';

export const renderRoutes = (routes = []) => {
    return (
        <Suspense fallback={<Loader />}>
            <Switch>
                {routes.map((route, i) => {
                    const Guard = route.guard || Fragment;
                    const Layout = route.layout || Fragment;
                    const Component = route.component;

                    const isAuthPath = ['/','/auth/signin', '/auth/signin-2', 'reset-password/:token', '/auth/reset-password', '/register/onboarding'].includes(
                        route.path
                    );

                    return (
                        <Route
                            key={i}
                            path={route.path}
                            exact={route.exact}
                            render={(props) => {
                                return (
                                    <Guard>
                                        {!isAuthPath ? (
                                            // <RoleBasedGuard path={route.path}>
                                            <Layout>{route.routes ? renderRoutes(route.routes) : <Component {...props} />}</Layout>
                                        ) : (
                                            // </RoleBasedGuard>
                                            <Layout>{route.routes ? renderRoutes(route.routes) : <Component {...props} />}</Layout>
                                        )}
                                    </Guard>
                                );
                            }}
                        />
                    );
                })}
            </Switch>
        </Suspense>
    );
};

const routes = [
    {
        exact: true,
        // guard: GuestGuard,
        path: '/',
        component: lazy(() => import('./views/landing/index'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/register/onboarding',
        component: lazy(() => import('./components/Registration'))
    },
   
    // {
    //     exact: true,
    //     guard: GuestGuard,
    //     path: '/admin/subscriptions',
    //     component: lazy(() => import('./components/Subscriptions'))
    // },
    {
        exact: true,
        guard: GuestGuard,
        path: '/auth/signin',
        component: lazy(() => import('./views/auth/signin/SignIn1'))
    },
    {
        exact: true,
        guard: GuestGuard,
        path: '/reset-password/:token',
        component: lazy(() => import('./views/auth/signup/SignUp1'))
    },
    {
        exact: true,
        path: '/auth/signin-2',
        component: lazy(() => import('./views/auth/signin/SignIn2'))
    },
    {
        exact: true,
        path: '/auth/reset-password',
        component: lazy(() => import('./views/auth/signup/SignUp2'))
    },
    {
        path: '*',
        layout: AdminLayout,
        guard: AuthGuard,
        routes: [
            {
                exact: true,
                path: '/app/dashboard',
                component: Dashboard,
                guard: RoleBasedGuard
            },
            
            {
                exact: true,
                path: '/users',
                guard: RoleBasedGuard,
                component: BasicButtons
            },
            {
                exact: true,
                path: '/payslip',
                guard: RoleBasedGuard,
                component: Payslip
            },
            {
                exact: true,
                path: '/profile',
                component: Profile,
                // guard: RoleBasedGuard,
            },
            {
                exact: true,
                path: '/users/roles',
                component: BasicBreadcrumbs01,
                guard: RoleBasedGuard
            },
          
            {
                exact: true,
                path: '/stakeholder/details/:id',
                component: StakeholderDetailPage
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/sales/view/:id',
                component: SalesViewPage
                // guard: RoleBasedGuard
            },
            
            {
                exact: true,
                path: '/users/details/:id',
                component: BasicButton1
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/users/admins/admin-details/:id',
                component: BasicButtons1
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/users/edit-salary/:salaryId',
                component: BasicButton22
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/reports/account-statement/:account_code/:account_name',
                component: GeneralLedgerReport
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/accounts/view-transaction/:id',
                component: BasicButton00122
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/users/payroll/salary_payment/:id',
                component: BasicButton1021
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/users/update-password/:id',
                component: BasicButton20
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/auth/password-change',
                component: BasicButton21
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/sales/edit/:id',
                component: SalesEditPage
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/animal-cycles',
                component: DefaultCyclePage,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/payroll/generate-payroll',
                component: BasicBadges,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/payroll/management',
                component: PayrollPaymentPage,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/attendance/clock',
                component: AttendanceClockPage,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/attendance/daily-logs',
                component: AttendanceDailyPage,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/leave/my-requests',
                component: LeaveRequestPage,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/leave/requests',
                component: HrLeaveRequestPage,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/leave/calendar-view',
                component: LeaveCalendarPage,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/bank/reconciliation',
                component: BankReconciliation,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/bank/reconciliation-report',
                component: ReconciliationReports,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/workspace',
                component: BasicBreadcrumb1,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/departments',
                component: HRManagement,
                guard: RoleBasedGuard
            },
           
            {
                exact: true,
                path: '/messages',
                component: nvd3Chart100,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/journals',
                component: ManualJournalList,
                guard: RoleBasedGuard
            },
           
            {
                exact: true,
                path: '/animals/mating',
                component: MatingRecords,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/poultry/report',
                component: BasicTabsPills101,
                guard: RoleBasedGuard
            },
           
            {
                exact: true,
                path: '/eggs-update',
                component: SamplePage9,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/eggs/collection',
                component: EggCollectionModal
                // guard: RoleBasedGuard
            },
         
            {
                exact: true,
                path: '/reports/inventory',
                component: SamplePage02R,
                guard: RoleBasedGuard
            },
           
            {
                exact: true,
                path: '/inventory',
                component: Inventory,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/inventory/item/:id',
                component: ItemDetailsPage
                // guard: RoleBasedGuard
            },
         
            {
                exact: true,
                path: '/inventory/add',
                component: InventoryAdd
                // guard: RoleBasedGuard
            },
           
            {
                exact: true,
                path: '/inventory/consumption',
                component: ConsumptionPages
               
            },
            {
                exact: true,
                path: '/inventory/reports',
                component: InventoryReport
            },
           
            {
                exact: true,
                path: '/payroll/salary-settings',
                component: SalarySettings,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/animal-growth',
                component: AnimalGrowthTracker,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/animal/waste-management',
                component: AnimalWasteManagement,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/slaughter/add',
                component: AddSlaughterWaste,
                // guard: RoleBasedGuard
            },
            // {
            //     exact: true,
            //     path: '/animal-growth-analytics',
            //     component: AnimalAnalyticsDashboard,
            //     guard: RoleBasedGuard
            // },
            {
                exact: true,
                path: '/weather/insights',
                component: BootstrapTable2,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/farm/profile',
                component: FarmProfile,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/stakeholders',
                component: Sample03,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/transactions',
                component: BootstrapTable02,
                guard: RoleBasedGuard
            },
          
            {
                exact: true,
                path: '/reports/production',
                component: SamplePage10,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/accounts/chart-accounts',
                component: SamplePage12,
                guard: RoleBasedGuard
            },
            
            {
                exact: true,
                path: '/internal-consumption',
                component: InternalConsumption,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/farm-items',
                component: FarmItems
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/earnings',
                component: SamplePage012
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/expenditure',
                component: SamplePage013
                // guard: RoleBasedGuard
            },
            
            {
                exact: true,
                path: '/sales',
                component: Sales,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/sales/create',
                component: SalesPage
                // guard: RoleBasedGuard
            },
           
            {
                exact: true,
                path: '/payments',
                component: SamplePage00014,
                guard: RoleBasedGuard
            },
           
            {
                exact: true,
                path: '/accountant/dashboard',
                component: AccountantDashboard,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/transactions/purchases',
                component: SamplePage0151,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/stock',
                component: SamplePage0101
                // guard: RoleBasedGuard
            },
            // {
            //     exact: true,
            //     path: '/stock/add-stock',
            //     component: SamplePage010
            //     // guard: RoleBasedGuard
            // },
            {
                exact: true,
                path: '/stock/consumption',
                component: SamplePage0102
                // guard: RoleBasedGuard
            },
           
            {
                exact: true,
                path: '/cash-flow',
                component: CashFlow,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/profit-loss',
                component: ProfitLoss,
                guard: RoleBasedGuard
            },
            
            {
                exact: true,
                path: '/logs',
                component: BasicTabsPills0003,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/farms',
                component: BasicTabsPills03,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/farms/add',
                component: BasicTabsPills003,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/farms/manage',
                component: BasicTabsPills0030,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/animal-assets',
                component: nvd3Chart03,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/animal-assets/mortality',
                component: AnimalMortalityHistory,
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/animal-assets/add-invoice',
                component: AssetPurchaseInvoice,
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/animal-assets/configure',
                component: AssetConfigPage,
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/animal-assets/silo-config',
                component: SiloManagement,
                // guard: RoleBasedGuard
            },
            
            {
                exact: true,
                path: '/reports/general-ledger',
                component: GeneralLedger,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/reports/trial-balance',
                component: TrialBalance,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/reports/balance-sheet',
                component: BalanceSheet,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/reports/income-statement',
                component: IncomeStatement,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/settings/animal-types',
                component: AnimalTypes,
                guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/income/:selectedFarm',
                component: BasicTabsPills0031
                // guard: RoleBasedGuard
            },

            {
                exact: true,
                path: '/expense/:selectedFarm',
                component: BasicTabsPills0033
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/sales/:selectedFarm',
                component: BasicTabsPills0035
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/acquisition/:selectedFarm',
                component: BasicTabsPills0037
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/loans/:selectedFarm',
                component: BasicTabsPills0039
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/payments/:selectedFarm',
                component: BasicTabsPills0041
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/balancesheet/:selectedFarm',
                component: BasicTabsPills0043
                // guard: RoleBasedGuard
            },
            {
                exact: true,
                path: '/settings',
                component: SettingsPage
                // guard: RoleBasedGuard
            },

          
            {
                path: '*',
                exact: true,
                component: () => <Redirect to={BASE_URL} />
            }
        ]
    }
];

export default routes;
